import { handleActions } from 'redux-actions';

const defaultTranslations = _.get(window, 'wix.translations', {});

export default handleActions({}, defaultTranslations);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/translations.js